import { useEffect, useState } from "react";
import { convertNumberToDecimal, getConformalValue, getStatsCellColor } from "../../../utils/formattingFns";

export default function StatsValue({
    value,
    isReversed,
    threshold,
}: {
    value: string,
    isReversed: boolean,
    threshold?: number,
}) {
    const [ color, setColor ] = useState('#E0E0E0');
    const [ valueLabel, setValueLabel ] = useState('');

    useEffect(() => {
            if (threshold && typeof value !== 'number') {
                const numArr = value.split(',').map(val => Number(val));
                const { color, label } = getConformalValue(numArr, threshold);
                setColor(color);
                setValueLabel(label);
            } else {
                setColor(getStatsCellColor({ min: 0, max: 1 }, Number(value), isReversed));
            }
                
            }, [value, threshold, isReversed]);


    return (
        <div style={{backgroundColor: color}} className="flex justify-center items-center py-1 px-3 rounded-lg text-default font-medium">
            {threshold && valueLabel ? (
                valueLabel
            ) : (
                convertNumberToDecimal(value)
            )}
        </div>
    )
}